import {DefaultTheme, createGlobalStyle} from 'styled-components';
import {themeGet} from '@styled-system/theme-get';


interface Theme {
    body: string;
    text: string;
    semiforeground: string;
    semibackground: string;
    shadow: string;
}

export const lightTheme: Theme = {
    body: '#ffffff',
    text: '#000000',
    semiforeground: '#292929',
    semibackground: '#f1f1f1',
    shadow: '#757575',
};

export const darkTheme: Theme = {
    body: '#000000',
    text: '#d5d5d5',
    semiforeground: '#ababab',
    semibackground: '#292929',
    shadow: '#000000',
};

// Extend DefaultTheme with your custom Theme type
interface ThemeProps extends DefaultTheme {
    theme: Theme;
    isTransitionEnabled?: boolean;
    isCodeWrapEnabled?: boolean;
}


export const GlobalStyles = createGlobalStyle<ThemeProps>`
  :root {
    --banner-size: 400px; // Standalone page banner height

    // General code
    --deckgo-highlight-code-white-space: pre;
      // --deckgo-highlight-code-white-space: ${({isCodeWrapEnabled}) => (isCodeWrapEnabled ? 'pre-wrap' : 'pre')};
      // ${({isTransitionEnabled}) => (isTransitionEnabled ? 'pre-wrap' : 'pre')}

    // Ubuntu
    --deckgo-lowlight-code-line-numbers-color: #DDD; // This effectively adds padding to ubuntu
    --deckgo-highlight-code-ubuntu-border-radius: 6px;
    --deckgo-highlight-code-ubuntu-header-background: linear-gradient(#59574f, #3e3d39);

    //Carbon
    --deckgo-highlight-code-carbon-border-radius: 6px;
    --deckgo-lowlight-code-line-opacity: 0.5;

    //--deckgo-highlight-code-background: linear-gradient(red, #0c1021);
    //--deckgo-highlight-code-ubuntu-background: 2d0922;
    --deckgo-highlight-code-margin: 0.5em 0 1em .5em;
    //--deckgo-highlight-code-white-space: pre;
    // TODO: Create a text wrap toggle in a MarkdownRemark hook


  }
  
  //.hide-scrollbar {
    &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  //}

  .grecaptcha-badge {
    visibility: hidden !important;
  }

  //Own scroll bar (insert cool-kid emoji)
  /* width */
  ::-webkit-scrollbar {
    width: 6px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background-color: ${({theme}) => theme.semibackground};
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background-color: ${({theme}) => theme.semiforeground};
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: ${({theme}) => theme.text};
  }

  .button-like {
      cursor: pointer;
      &:hover {
          color: blue;
      }
  }  
  /*
  header, body, footer span,
  .post-title, footer,
  div.intro-image, .border-line,
  svg:not(.transition-escape), .stand-alone-wrapper-styling,
  .transition-join, .linear-wipe, input, textarea, .recaptcha-dark, .recaptcha-light {
    :not(.post-title):not(svg):not(h1):not(h2):not(h3):not(h4):not(svg):not(code):not(input):not(textarea):not(blockquote) {
      background-color: ${({theme}) => theme.body};
      color: ${({theme}) => theme.text};
    }

    transition: ${({isTransitionEnabled}) =>
          (isTransitionEnabled ?
                          'color 3s ease-in, ' +
                          'background-color 3s ease-in, ' +
                          'background 3s ease-in, ' +
                          'box-shadow 3s ease-in, ' +
                          'text-shadow 3s ease-in, ' +
                          'opacity 3s ease-in, ' +
                          'border-color 3s ease-in' : 'none'
          )}
  }
  */
  :root {
    background-color: ${({theme}) => theme.body};
    color: ${({theme}) => theme.text};
  }
  iframe {
    // This centers iframes if they do not have full width
    // I think this already happens to images...
    margin: auto;
  }
  .post-preview, .banner-image, .mermaid, iframe, img:not(.icon) {
    filter: brightness(${({theme}) => theme === darkTheme ? '90' : '100'}%);
      /*
    transition: ${({isTransitionEnabled}) =>
            (isTransitionEnabled ?
                            'transition: filter .3s ease-in, ' : 'none'
            )}
     */
  }

  /*
  blockquote {
    // in post dails, but why
    transition: ${({isTransitionEnabled}) => (isTransitionEnabled ? 'background-color .3s ease-in' : 'none')};
  }
  */
  /*
  :not(li) {
    code:not([slot="user"]) {
      background-color: ${({theme}) => theme.semibackground} !important;
      // transition: ${({isTransitionEnabled}) => (isTransitionEnabled ? 'background-color .3s ease-in' : 'none')};
      //   // this rule was somehow overwritten by the transition part in the top of this code,
      //   // which was messing up the background. When I would add it to the exclusion list, also  
      //   // other stuff would be excluded. Strange stuff, this may be a better solution for now.
    }
  }
  */
  /*
  li {
    code:not([slot="user"]) {
      background-color: ${({theme}) => theme.body} !important;
      transition: ${({isTransitionEnabled}) => (isTransitionEnabled ? 'background-color .3s ease-in' : 'none')};
      //   // this rule was somehow overwritten by the transition part in the top of this code,
      //   // which was messing up the background. When I would add it to the exclusion list, also  
      //   // other stuff would be excluded. Strange stuff, this may be a better solution for now.
    }
  }
  */
  //}
  //  .post-preview::after and  templatesstyle__RelatedPostTitle-gtWCyi iwKQld::after
  img {
    box-shadow: none !important; // Why was this being set in the first place?
  }

  html {
    box-sizing: border-box;
    -ms-overflow-style: scrollbar;
  }

  //img {
  //  max-width: 100%; //handles images on blog post pages
  //}
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html,
  html a,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  a,
  p,
  li,
  dl,
  th,
  dt,
  input,
  textarea,
  span,
  div {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 0;
    font-family: 'Poppins', sans-serif;
  }

  body {
    font-family: 'Fira Sans', sans-serif;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    -webkit-tap-highlight-color: transparent;
  }

  p {
    font-size: ${themeGet('fontSizes.3', '15')}px;
    line-height: 1.7em;
    margin: 0 0 1.7em 0;
  }


  input, textarea, select, button {
    font-family: 'Fira Sans', sans-serif;
  }

  ul, ol {
    margin-botton: 0 inherit !important; // default bottom is 2 rem, which is too much
    padding: 0;
  }

  .gatsby-remark-prismjs-copy-button-container {
    // Set container location
    margin-right: 12px;
    height: 24px; // make sure SVGs scale around center
    translate: 0 -8px; // reposition after scaling
    div, div:hover {
      // Unset much of the default formatting
      font-size: 0;
      background-color: unset;
      transition: transform ease-out .2s;
      // Turn off the fade out animation of the confirmation button
      &.copied {
        animation: none;
      }

      // Set content of the buttons
      :after {
        content: url('/copied.svg');
      }

      :not(.copied):after {
        content: url('/copy.svg');
      }

      transform: scale(0.7);
      // Set size increase when possible
      @media (hover: hover) {
        :hover {
          transform: scale(1);
        }
      }
    }
  }

  a {
    text-decoration: none;
    box-shadow: none;
  }

  a:hover {
    text-decoration: none;
  }

  blockquote {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
  }

  .gatsby-code-title {
    height: 0;
    display: block;
    position: relative;
    width: 100%;
    top: 7px;
    left: 72px;
  }

  .gatsby-code-title span {
    padding: 8px;
    font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
    color: #d5d5d5;
    font-size: 12px;
  }

  //
  // :not(pre) > code[class*="language-"], pre[class*="language-"] {
  //   background: ${({theme}) => theme.semibackground};
  // }
  //
  // .gatsby-highlight pre[class*="language-"]  {
  //   border-radius: 6px;
  //   padding-left: 3em !important; // Saves us 0.8 em on horizontal space
  //   margin-top: 0; // every <p> already comes with a 16px margin-bottom
  //   margin-bottom: 16px;
  // }
  // //
  // // .language-css .token.string, .style .token.string, .token.entity, .token.operator, .token.url {
  // //     //background: ${({theme}) => theme.semibackground};
  // //     background: transparent;
  // // }
  // //
  // // code[class*=language-], pre[class*=language-] {
  // //   color: ${({theme}) => theme.text};
  // //   text-shadow: 0 1px ${({theme}) => theme.body};
  // // }
  // //
  // // pre[class*="language-"] {
  // //   padding: 1.5em;
  // //   margin: 2em 0;
  // //   overflow: auto;
  // // }
  //// Code block formatting
  //.line-numbers-rows > span::before {
  //    color: #999;
  //}
  //.line-numbers-rows {
  //  margin-top: 26px;
  //  border-right: 1px solid #999;
  //}
  //[data-language="html"], [data-language="bash"] { 
  //  .line-numbers-rows {
  //    display: none;
  //  }
  //}
  table {
    display: block; //allows for scrolling
    overflow: auto;
    //width: auto;
    margin: 0 auto 2em auto;
    //border-collapse: collapse;
    border-spacing: 0;
    line-height: 1.6;
  }

  table tr {
    background-color: ${({theme}) => theme.body};
    border-top: 1px solid #c6cbd1;
  }

  table tr:nth-child(2n) {
    background-color: ${({theme}) => theme.semibackground};
  }

  table th {
    font-weight: 500;
  }

  table td,
  table th {
    border: 1px solid ${({theme}) => theme.semibackground};
    padding: .4em 1em;
  }

  .nav-sticky {
    .header {
      box-shadow: 0 0 15px rgba(0, 0, 0, .08);

      .navbar {
        @media (min-width: 1400px) {
          padding-top: 25px;
          padding-bottom: 25px;
        }
        @media (min-width: 1200px) {
          padding-top: 20px;
          padding-bottom: 20px;
        }
      }
    }
  }

  deckgo-highlight-code {
    margin-top: 0;
  }

  }

  //object {
  //  height: 18px;
  //  width: 16px;
  //  cursor: pointer;
  //  pointer-events: none;
  //  @media (hover: hover) {
  //    :hover {
  //      color: #2251ff; /* Change color on hover */
  //    }
  //  }
  //}
`

